module.exports = __webpack_public_path__ + "img/10-4.65296b36.png";